import { Directive, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({
  selector: 'input[ospTrimInput], textarea[ospTrimInput]',
  standalone: true,
})
export class TrimInputDirective {
  private _trimEnabled = false;
  private originalRegisterOnChange: (fn: unknown) => void = () => { };
  private trimString = (value: unknown): unknown =>
    typeof value === 'string' && this._trimEnabled ? value.trim() : value;

  @Input({ alias: 'ospTrimInput' }) set trimEnabled(value: boolean) {
    this._trimEnabled = value;
  }
  public get trimEnabled(): boolean {
    return this._trimEnabled;
  }

  constructor(private ngControl: NgControl) {
    if (this.ngControl.valueAccessor) {
      this.trimValueAccessor(this.ngControl.valueAccessor);
    }
  }

  @HostListener('blur')
  public onBlur() {
    if (this._trimEnabled) {
      const control = this.ngControl.control;
      if (control) {
        const original = control.updateValueAndValidity;
        control.updateValueAndValidity = () => { };

        control.setValue(
          this.trimString(control.value),
          { emitValue: false, onlySelf: true }
        );

        control.updateValueAndValidity = original;
      }
    }
  }

  private trimValueAccessor(valueAccessor: ControlValueAccessor) {
    this.originalRegisterOnChange = valueAccessor.registerOnChange;
    const trimString = this.trimString;

    valueAccessor.registerOnChange = (fn) => {
      return this.originalRegisterOnChange.call(
        valueAccessor,
        (value: string) => fn(trimString(value))
      );
    };
  }
}
